import { render, staticRenderFns } from "./DeleteModulesToInventory.vue?vue&type=template&id=68507b84&"
import script from "./DeleteModulesToInventory.vue?vue&type=script&lang=js&"
export * from "./DeleteModulesToInventory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports